import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { DriverMetricRecommendationUpdateInput } from '../generated/globalTypes';
import { updateDriverMetricRecommendationMutation, updateDriverMetricRecommendationMutationVariables } from '../generated/updateDriverMetricRecommendationMutation';
import { driverMetricRecommendationFieldsFragment } from '../models/DriverMetricRecommendation';

/**
 * Get a callback to update a DriverMetricRecommendation in the store.
 */
export function useUpdateDriverMetricRecommendationCallback(): [(id: string, model: DriverMetricRecommendationUpdateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<updateDriverMetricRecommendationMutation, updateDriverMetricRecommendationMutationVariables>(
        gql`
            mutation updateDriverMetricRecommendationMutation ($model: DriverMetricRecommendationUpdateInput!) {
                updateDriverMetricRecommendation(model: $model) {
                    ...driverMetricRecommendationFields
                }
            }

            ${driverMetricRecommendationFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string, model: DriverMetricRecommendationUpdateInput) => {
        const result = await mutationAction({ variables: { model: { ...model, id: id } } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
